export default function reCaptchaOnFocus() {
  var head = document.getElementsByTagName('head')[0]
  var script = document.createElement('script')
  script.type = 'text/javascript';
  script.src = 'https://www.google.com/recaptcha/api.js?onload=captchaCallback&render=explicit'
  
  head.appendChild(script);
  
  if (document.getElementById('remember-email')) {
    document.getElementById('remember-email').removeEventListener('focus', reCaptchaOnFocus);
  }
  if (document.getElementById('ddlWhereDidYouHear')) {
    document.getElementById('ddlWhereDidYouHear').removeEventListener('focus', reCaptchaOnFocus);
  }
  if (document.getElementById('tbxName')) {
    document.getElementById('tbxName').removeEventListener('focus', reCaptchaOnFocus);
  }
  if (document.getElementById('tbxEmail')) {
    document.getElementById('tbxEmail').removeEventListener('focus', reCaptchaOnFocus);
  }
  if (document.getElementById('tbxComment')) {
    document.getElementById('tbxComment').removeEventListener('focus', reCaptchaOnFocus);
  }
};
